import { BaseDataItem, SVGDataItem, VectorImageData } from '@wix/thunderbolt-becky-types'
import { CatharsisArgs } from '@wix/thunderbolt-catharsis'
import { isValidShape } from './shapeIdsNode'

const isVectorImage = (dataItem: BaseDataItem) => dataItem.type === 'VectorImage'
const isSVGItem = (dataItem: BaseDataItem) => dataItem.type === 'SVGItem'

const isShapeItem = (aspect: string, dataItem: BaseDataItem): dataItem is VectorImageData | SVGDataItem =>
	(aspect === 'document_data' && isVectorImage(dataItem)) || isSVGItem(dataItem)

export const getInvalidationHandler = (set: Set<string>): CatharsisArgs['onInvalidation'] => (path, get) => {
	const [, aspect] = path
	if (aspect === 'shapeIds' || aspect === 'cursorShapeIds') {
		const value = get<Array<string> | undefined>(path)
		if (value) {
			value.forEach((id) => set.add(id))
		}
	}

	// TODO: Remove this in an experiment to and use only components mappers to find svgIds.
	const dataItem = get<BaseDataItem>(path)
	if (dataItem && isShapeItem(aspect, dataItem) && isValidShape(dataItem.svgId)) {
		set.add(dataItem.svgId)
	}
}
